import { render } from "./EventViewDetail.vue?vue&type=template&id=eed8f338&scoped=true"
import script from "./EventViewDetail.vue?vue&type=script&lang=js"
export * from "./EventViewDetail.vue?vue&type=script&lang=js"

import "./EventViewDetail.vue?vue&type=style&index=0&id=eed8f338&scoped=true&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eed8f338"]])

export default __exports__